module.exports = __webpack_public_path__ + "media/images/icons/swiper-arrow-left-c21dc3e95bdd503156c0c23e348ed7e7.svg";